import { render, staticRenderFns } from "./specialGoods.vue?vue&type=template&id=5a5d1aef&scoped=true&"
import script from "./specialGoods.vue?vue&type=script&lang=js&"
export * from "./specialGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5d1aef",
  null
  
)

export default component.exports